module.exports = __webpack_public_path__ + "static/sprite-88435c103a7d8e3961a3808ce6ccbf6b.svg";